import Styles from './styles.module.css';
import React from 'react';
import { doc, getFirestore, updateDoc } from 'firebase/firestore';
import { useAppSelector } from 'src/salon/app/hook';
import { useNavigate } from 'react-router-dom';

type SchoolUnPublicProps = {
  // 確定後の移動先(SendModal の completePath と同じ)
  completePath: string;
};

const SchoolUnPublic: React.FC<SchoolUnPublicProps> = ({ completePath }) => {

  const db = getFirestore();
  const navigate = useNavigate();

  const company = useAppSelector((state) => state.company.company);

  const unPublic = async () => {
    const refs = doc(db, "companies", company.id);
    await updateDoc(refs, {
      "progress.sending": true
    });

    navigate(completePath);
  }

  return (
    <>
    <div className={Styles.modal_contents}>
      <h4>有料プランをご契約の事業者様へ</h4>
      <p className={Styles.modal_contents_p}>有料プランの事業者様は全学校へ自動送付されますので、学校選択は不要となります。</p>
      <button type='button' onClick={() => unPublic()}>確定する</button>
    </div>
    </>
  );
}

export default SchoolUnPublic;
